import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { User } from '../../models/User'

import { RootState } from '../store'

interface DocumentUsersState {
  currentUser: User | null
  currentUserIsLoading: boolean
  contact: User | null
  contactIsLoading: boolean
}

const initialState: DocumentUsersState = {
  currentUser: null,
  currentUserIsLoading: false,
  contact: null,
  contactIsLoading: false,
}

export const documentUserSlice = createSlice({
  name: 'documentUsers',
  initialState,
  reducers: {
    setProcessDocumentCurrentUser: (state, action: PayloadAction<User>) => {
      state.currentUser = action.payload
    },
    setProcessDocumentCurrentUserIsLoading: (state, action: PayloadAction<boolean>) => {
      state.currentUserIsLoading = action.payload
    },
    setProcessDocumentContact: (state, action: PayloadAction<User>) => {
      state.contact = action.payload
    },
    clearProcessDocumentContact: (state) => {
      state.contact = null
    },
    setProcessDocumentContactLoading: (state, action: PayloadAction<boolean>) => {
      state.contactIsLoading = action.payload
    },
    resetProcessDocumentUsers: () => initialState,
  },
})

export const {
  setProcessDocumentContact,
  clearProcessDocumentContact,
  setProcessDocumentContactLoading,
  setProcessDocumentCurrentUser,
  setProcessDocumentCurrentUserIsLoading,
  resetProcessDocumentUsers,
} = documentUserSlice.actions

export const selectProcessDocumentContact = (state: RootState) => state.processDocument.documentUsers.contact

export const selectProcessDocumentContactLoading = (state: RootState) => state.processDocument.documentUsers.contactIsLoading

export const selectProcessDocumentCurrentUser = (state: RootState) => state.processDocument.documentUsers.currentUser

export const selectProcessDocumentCurrentUserLoading = (state: RootState) => state.processDocument.documentUsers.currentUserIsLoading

export const selectProcessDocumentCurrentUserEmailIntegration = (state: RootState) => {
  const currentUser = state.processDocument.documentUsers.currentUser
  if (!currentUser) {
    return null
  }
  return currentUser.integrations?.find((integration) => integration.type === 'mail') ?? null
}
